// The editor through an upstream blip. On 20 Oct (Admiral rehearsal) workspace/me and preview-ticket answered 401 for
// a few seconds while Xano hiccupped, and the canvas told a signed-in person to sign in again. Now a 401, 429, 5xx or
// dropped connection is retried once after RETRY_DELAY_MS, and the canvas says "Sign in again" only when the
// dashboard's own sign-in (Xano auth/me) also says the session is over; otherwise "Bloxx couldn't reach the server".
// Pure functions, so test/site-workspace/connection.test.mjs runs them in node.
import { isNotDeployed } from "./api";

export const RETRY_DELAY_MS = 1500;

const statusOf = (e: unknown): number | null => {
  const s = (e as { status?: unknown } | null)?.status;
  return typeof s === "number" ? s : null;
};

/** Retry once, unless the route is not deployed or the answer is final (403 no access, 404 no such thing). */
export function retryOnceTransient(failures: number, e: unknown): boolean {
  // A read that already waited its whole timeout is not waited on twice: the canvas says so and retries on its own.
  if (failures >= 1 || isNotDeployed(e) || (e as { code?: unknown } | null)?.code === "timeout") return false;
  const s = statusOf(e);
  return s === null || (s !== 403 && s !== 404);
}

/** What the dashboard's own sign-in says: still valid, over (401/403 from auth/me), unknown (it failed too), or asking. */
export type SessionCheck = "valid" | "invalid" | "unknown" | "checking";
export type PreviewProblem = { kind: "signin" } | { kind: "unreachable" } | { kind: "other"; message: string };

/** How the canvas words a failure after its retry. */
export function previewProblem(e: unknown, session: SessionCheck): PreviewProblem {
  const s = statusOf(e);
  if (s === 401) return session === "invalid" ? { kind: "signin" } : { kind: "unreachable" };
  if (s === null || s === 0 || s === 408 || s === 429 || s >= 500) return { kind: "unreachable" };
  return { kind: "other", message: (e as Error)?.message || "That did not work. Try again in a moment." };
}
